// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__6lFrm","insightsList":"newBusinessInsightsMenu_insightsList__3i4OD","active":"newBusinessInsightsMenu_active__bWXWL"};